export default import.meta.ROLLUP_FILE_URL_AxY3E6ul0Tvg$BFpCmgmrg